export const TYPES = Object.freeze({
  DATE: 'single-date',
  FLEX: 'flex-date'
});

export const PRICE_TYPES = Object.freeze({
  DATE: 'date',
  DAY_OF_WEEK: 'day-of-week',
  DELIVERY_DAY_INDEX: 'delivery-day-index',
  FLEX: 'flex',
  RUSH: 'rush',
  NONE: 'none'
});

export const PRICE_SOURCES = Object.freeze({
  DATE_FEE: 'date-fee',
  DELIVERY_METHOD: 'delivery-method',
  FEE_TEST: 'fee-test',
  FLEX_DATE: 'flex-date',
  ZIP_CODE: 'zip-code',
  NONE: 'none'
});
